export const environment = {
  production: true,
  apiUrl: 'https://aquila-v2-sit.apps.qeema.io',
  reportApiUrl:
    'https://aquila-v2-sit.apps.qeema.io/api/cem/reporting/apigateway/api/auth',
  authUrl: 'https://aquila-v2-sit.apps.qeema.io',
  languageFilesPath: '/assets/i18n/',
  loginPath: '/login',
};
